import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { UserCompetencyStatus } from '@core/entities/competency/UserCompetency/types'
import { ICompetencyAssignmentNotification } from './ICompetencyAssignmentNotification'

export class CompetencyAssignmentNotification extends Entity<ICompetencyAssignmentNotification> {
  id: number
  organisationId: number
  userId: number
  templateId: number
  competencyName?: string
  status: UserCompetencyStatus
  expiresOn?: string

  public static new(
    payload: ICompetencyAssignmentNotification,
  ): CompetencyAssignmentNotification {
    return plainToInstance(CompetencyAssignmentNotification, payload)
  }
}
